import { Calendar } from "primereact/calendar";
import React from "react";
import { FormSectionElements, FormSubSections } from "src/entities/formTemplateDataType";
import XMLParser from "../../utilities/XMLParser";
import classNames from 'classnames';
import FormValidationUtils from "../../utilities/FormValidationUtils";
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import Utils from "../../utilities/Utils";
import { getRootComponent } from "../../utilities/ElementUtils";


interface Props {
  field: FormSectionElements;
  editable: boolean;
  title;
  labelControlArray;
  requiredField;
  callbackElement;
  isEng: boolean;
  usedForFilter;
}

interface State {
  
}
export class CheckboxWithTextboxComponent extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);

    let field = this.props.field;
      FormValidationUtils.runJavascript(field);
  }

  onInputChange = (e) => {
    const val = e.target.value;
    let field = this.props.field;
    field.Value = val;

    FormValidationUtils.validateCheckbobWithInput(field);
    
    if(val && !field.Checked){
      field.Optional="N";
      field.Valid=false;
      field.Touched=true;
      field.IsEmpty=true;
    } else if (val) {
      field.Valid=true;
    }

    if (field.Script) {
      const customJSFunc = eval(`(${field.Script})`);
      customJSFunc();
    }

    this.props.callbackElement(getRootComponent(this.props.field));
  }

  onCheckboxChange=(e)=>{
    let field = this.props.field;
    field.Checked = e.target.checked;
    field.Optional = field.Checked ? "N" : "Y";
    if (field.Checked && Utils.isNullOrEmpty(field.Value)) {
      field.Valid = false;
      field.Touched = true;
      field.IsEmpty=true;
    } else {
      field.Valid = true;
    }

    if (field.Checked == false) {
      field.Value = "";
      field.Valid = true;
    }

    this.props.callbackElement(getRootComponent(this.props.field));
  }

  render() {   
    let field = this.props.field;
    let editable = this.props.editable;
    let controlArray = [];
    let title = this.props.title;
    const validClass = field.Length?'ontario-input' +  " " + field.Length: 'ontario-input';
    const invalidClass = field.Length?'ontario-input' +  " " + field.Length + ' ontario-input__error' :'ontario-input ontario-input__error';

    if (editable) {
      controlArray.push(
        <div key={'div_' + field.Datatype + '_' + field.Id} id={'div_' + field.Datatype + '_' + field.Id}>
          <div className="ontario-checkboxes" key={'fd_Checkbox' + field.Sequence} title={field.TooltipENU}>

            <div className="ontario-checkboxes__item">
              <input
                className={field.Valid? "ontario-checkboxes__input":"ontario-checkboxes__input ontario-checkboxes__error"}
                id={field.LoadBindName} 
                key={'checkboxes__input' + field.Id}
                name="options"
                type="checkbox"
                onChange={(e) => {
                  this.onCheckboxChange(e);
                }}>
              </input>
              <label
                className="ontario-checkboxes__label"
                htmlFor={field.LoadBindName}
                style={{ display: 'inline-flex', flex: '0 0 auto' }}
              >
                {title}
              </label>

            </div>
            <div>
              <LiveValidationErrMsg
                field={this.props.field}
                isEng={this.props.isEng}
                key={"LiveValidationErrMsg_" + this.props.field.LoadBindName} />
            </div>       
            <div>
              <input  value={field.Value}       
              className={field.Valid || (!field.Valid &&!field.Touched) ?validClass:invalidClass}
        
                onChange={this.onInputChange}></input>
            </div>
          </div>
        </div>
      );
    } else {
      controlArray.push(
        <div className='pdf-two-column'>
          <div>{field.ENUTitle}</div>
          <div>
            {field.Value}
          </div>
        </div>
      )
    }

    return controlArray;
  }
}
